import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FrLoading = _resolveComponent("FrLoading")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.link ? _ctx.RouterLink : 'button'), _mergeProps(_ctx.$attrs, {
    to: _ctx.to,
    disabled: _ctx.disabled,
    type: _ctx.type,
    class: ["font-bold rounded transition-colors ease-in-out duration-150 focus:border-blue-700", [_ctx.classes]]
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.loading)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 })
          : (_openBlock(), _createBlock(_component_FrLoading, { key: 1 }))
      ])
    ]),
    _: 3
  }, 16, ["to", "disabled", "type", "class"]))
}